import { render } from "./FIT.vue?vue&type=template&id=52b5c228&scoped=true"
import script from "./FIT.vue?vue&type=script&lang=js"
export * from "./FIT.vue?vue&type=script&lang=js"

import "./FIT.vue?vue&type=style&index=0&id=52b5c228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b5c228"]])

export default __exports__